import { Injectable } from '@angular/core';
import { BrowserXhr } from "@angular/http";

@Injectable()
export class CustomBrowserXhr extends BrowserXhr {

  pendingRequests: number = 0;
  showLoading: boolean = false;

  constructor() {
    super();
  }

  build(): any {
    let xhr = super.build();
    var progressBar = document.getElementById("progress");
    let self = this;

    if (progressBar) {
      //upload
      xhr.upload.onprogress = function (e) {
        if (e.lengthComputable) {
          progressBar.setAttribute('max', e.total);
          progressBar.setAttribute('value', "" + (parseFloat(e.loaded) * 100) / parseFloat(e.total));
        }
      }
      xhr.upload.onloadstart = function (e) {
        progressBar.setAttribute('value', "10");
        self.turnOnSpinner();
      }
      xhr.upload.onloadend = function (e) {
        progressBar.setAttribute('value', e.loaded);
        self.turnOffSpinner();
      }

      //download
      xhr.onprogress = function (e) {
        if (e.lengthComputable) {
          progressBar.setAttribute('max', e.total);
          progressBar.setAttribute('value', "" + (parseFloat(e.loaded) * 100) / parseFloat(e.total));
        }
      };
      xhr.onloadstart = function (e) {
        progressBar.setAttribute('value', "10");
        self.turnOnSpinner(e && e.currentTarget ? e.currentTarget.__zone_symbol__xhrURL : "");
      };
      xhr.onloadend = function (e) {
        progressBar.setAttribute('value', e.loaded);
        self.turnOffSpinner();
      };
    }
    return <any>(xhr);
  }

  private turnOnSpinner(xhr = "") {
    this.pendingRequests++;
    if (!this.showLoading) {
      this.showLoading = true;
      let spinner = document.querySelector(".container-spinner");
      if (spinner && this.useRequestLoading(xhr)) {
        spinner["style"].display = "block";
      }

      let progressBar = document.getElementById("progress");
      if (progressBar && this.useRequestLoading(xhr)) {
        progressBar["style"].display = "block";
      }
    }
    this.showLoading = true; 
  }

  private turnOffSpinner() {
    this.pendingRequests--;
    if (this.pendingRequests <= 0) {
      if (this.showLoading) {
        let spinner = document.querySelector(".container-spinner");
        if (spinner) {
          spinner["style"].display = "none";
        }

        let progressBar = document.getElementById("progress");
        if (progressBar) {
          progressBar["style"].display = "none";
        }
      }
      this.showLoading = false;
    }
  }

  private useRequestLoading(url: string): boolean {
    url = url.toLocaleLowerCase();
    if(url.includes("/api/validador/cli/recursos/"))
      return true;
    if(url.includes("/api/validador/cli/executartodos/"))
      return true;
    if (url.includes("/api/validador/"))
      return false;
    
    return true;
  }
  
}



// WEBPACK FOOTER //
// ./src/app/utils/custom-browser-xhr.service/custom-browser-xhr.service.ts